import React from "react"
import NewUserForm from "../components/new-user/NewUserForm"

const SignInPage = (): JSX.Element => {
  return (
    <NewUserForm signIn userRole="borrower"/>
  )
}

export default SignInPage
